var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo-char char-animate ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.9,
    height: 7.2,
    viewBox: "0 0 17.9 27.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44568",
    "data-name": "Path 44568",
    d: "M9.4,14.2c1.8-2.6,6-8.8,7.3-10.9.1-.2.2-.4.5-.4h3.5c.3-.1.3.1.3.3-1.6,2.3-6.2,8.9-8.2,11.6-.4.6-.4.8-.4,1a1.854,1.854,0,0,0,.4,1c2.1,2.9,7.7,11.2,8.6,12.8,0,.3-.1.4-.3.4H17.6c-.3,0-.6-.2-.6-.4-1.3-2.1-5.7-9.1-7.6-11.9-.3-.5-.6-.5-1.6-.5-.2,0-.2.1-.2.2V29.5c-.2.4-.3.5-.6.5H3.9a.43.43,0,0,1-.4-.4V3.2a.43.43,0,0,1,.4-.4H7a.43.43,0,0,1,.4.4v11c0,.2.2.2.4.2C8.9,14.5,9.3,14.4,9.4,14.2Z",
    transform: "translate(-25.5 -2.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrish);
export default __webpack_public_path__ + "static/media/krish.d2e5ba5afebc518c4d26b69db2ec33be.svg";
export { ForwardRef as ReactComponent };